


























































import { Vue, Component, Prop } from 'vue-property-decorator';
import ModalComponent from '@/shared/modal/modal.component.vue';
import ModalOptions from '@/shared/modal/modal-options.entity';
import AuthenticationService from '@/domain/security/authentication.service';
import AuthorityService from '@/domain/security/authority.service';
import UserBusinessUnitService from '@/domain/business-unit/service/business-unit.store';
import BusinessUnit from '@/domain/business-unit/entity/business-unit.entity';

@Component({
  components: {
    ModalComponent,
  },
})
export default class MyAccountModal extends Vue {
  @Prop({ required: true, default: false }) showModal!: boolean;

  authorities: string[] = [];

  created() {
    AuthorityService.authorities()
      .then((resp: string[]) => { this.authorities = resp; });
  }

  get name(): string {
    return AuthenticationService.userLoggedIn().name;
  }

  get email(): string {
    return AuthenticationService.userLoggedIn().email;
  }

  get businessUnits(): BusinessUnit[] {
    return UserBusinessUnitService.businessUnits;
  }

  close(): void {
    this.$emit('close');
  }

  get options(): ModalOptions {
    return {
      title: 'Minha Conta',
      titleAlign: 'center',
      showClose: true,
      showOk: false,
      showCancel: true,
      labelCancel: 'Fechar',
      width: 600,
      persistent: false,
    };
  }
}
